const inAYear = () => new Date(Date.now() + 3600000 * 24 * 365);

export default inAYear;